// Gatsby requirements
import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionHero.module.scss'

const SectionHero = ({ blok }) => {
          
    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">
                <div className={CSS.text}>
                    {blok.richtext &&
                        <RichTextRenderer data={blok.richtext} />
                    }
                </div>
            </div>

            <picture>
                <source media="(max-width: 500px)"
                    srcSet={`
                        ${blok.backgroundImage.filename + '/m/500x500/filters:quality(90)'} 500w,
                        ${blok.backgroundImage.filename + '/m/400x400/filters:quality(90)'} 400w,
                        ${blok.backgroundImage.filename + '/m/300x300/filters:quality(85)'} 300w
                    `}
                />
                <source media="(min-width: 501px)"
                    srcSet={`
                        ${blok.backgroundImage.filename + '/m/2500x0/filters:quality(90)'} 2500w,
                        ${blok.backgroundImage.filename + '/m/2000x0/filters:quality(90)'} 2000w,
                        ${blok.backgroundImage.filename + '/m/1600x0/filters:quality(90)'} 1600w,
                        ${blok.backgroundImage.filename + '/m/1400x0/filters:quality(90)'} 1400w,
                        ${blok.backgroundImage.filename + '/m/1000x0/filters:quality(90)'} 1000w,
                        ${blok.backgroundImage.filename + '/m/900x0/filters:quality(90)'} 900w,
                        ${blok.backgroundImage.filename + '/m/800x0/filters:quality(90)'} 800w,
                        ${blok.backgroundImage.filename + '/m/700x0/filters:quality(90)'} 700w,
                        ${blok.backgroundImage.filename + '/m/600x0/filters:quality(90)'} 600w,
                    `}
                />
                <img
                    sizes="(min-width: 1200px) 150vw, 100vw"
                    src={blok.backgroundImage.filename}
                    width={blok.backgroundImage.filename?.split('/')[5]?.split('x')[0]}
                    height={blok.backgroundImage.filename?.split('/')[5]?.split('x')[1]}
                    alt={blok.backgroundImage?.alt}
                    loading="eager"
                />
            </picture>

        </section>
    )
}

export default SectionHero